import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import './TextContent.scss'

const TextContent = ({ component }) => {
  const content = component.textContent?.content
  const title = component.textContent?.title
  const bgImage = component.textContent?.backgroundImage?.url

  return (
    <div
      className="container-text mt-3 mt-xl-5  mb-3 mb-xl-5 container"
      style={{
        backgroundImage: `url(${bgImage})`
      }}
    >
      {component.textContent.variant === 'contained' ? (
        <div className="container text">
          <div className="title">
            <h2 className="titleText">{title}</h2>
          </div>
          <ReactMarkdown
            renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
            children={content}
            className="description"
            style={{ margin: !bgImage && '0rem' }}
          />
        </div>
      ) : (
        <div className="text-regular">
          <div className="title-regular">
            <h2 className="titleTextRegular pt-3 ps-md-0 pt-md-3">{title}</h2>
          </div>
          <ReactMarkdown
            renderers= {{link: ({node, ...props}) => <a {...props} target="_blank" rel="noopener noreferrer"/>}}
            rehypePlugins={false}
            children={content}
            className="markdown-format"
          />
        </div>
      )}
    </div>
  )
}

export default TextContent

TextContent.propTypes = {
  component: PropTypes.object.isRequired
}